export { BookIcon } from './BookIcon';
